// extracted by mini-css-extract-plugin
export var deleteIcon = "_rg-5";
export var deleteOption = "_rg-3";
export var divider = "_rg-2";
export var downloadIcon = "_rg-4";
export var drawer = "_rg-0";
export var drawerFooter = "_rg-6";
export var drawerOpen = "_rg-1";
export var highlighted = "_rg-7";
export var lighterHighlight = "_rg-8";